import Repository from "@/repository";

export default {
  namespaced: true,

  state: {
    complexes: [],
  },

  actions: {
    async fetchTiresComplexes({ commit }, { tireId, secondTireId = null }) {
      const { value, error } = await Repository.Tires.getComplexes(
        tireId,
        secondTireId
      );
      if (!error && value) {
        commit("setTiresComplexes", value);
      }
    },
  },

  mutations: {
    setTiresComplexes(state, value) {
      state.complexes = value;
    },
    resetComplexes(state) {
      state.complexes = [];
    },
  },
};
